import * as React from 'react';
import DynamicIcon from './dynamicicon';
import JisButton from './controls/jisButton';

export default function JisDialog({children,title=""}) {

  return (
    <div className={ "dialog-box open" }>          
        <div className="wrapper">  
          <div className='panel'>
            <div className='title'>
              {title}
            </div>
            <div className='panel-body'>
              {children}  
            </div>
            </div> 
          
        
    </div>
</div>

  );
}
